<template>
    <div :id="'quesito-' + id">
        <div class="card shadow rounded">
            <div class="card-header rounded d-flex justify-content-between bg-primary text-white">
                <b>Parere {{ id }}</b>
                <span v-if="emission_date">{{ convertDate(emission_date) }}</span>
            </div>
            <div class="card-body" style="overflow: auto;">
                <table class="table">
                    <tbody>
                        <tr>
                            <td class="label-data">Argomenti</td>
                            <td class="opinion-data d-flex flex-wrap justify-content-start align-items-start">
                                <span class="text-white bg-primary rounded p-1 me-2 mb-2" v-for="argument in arguments"
                                    :key="argument.id">
                                    {{ argument.title }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td class="label-data">Oggetto</td>
                            <td class="opinion-data"><b>{{ subject }}</b></td>
                        </tr>
                        <tr>
                            <td class="label-data">Quesito</td>
                            <td class="opinion-data">{{ stripHtml(question) }}</td>
                        </tr>
                        <tr>
                            <td class="label-data">Risposta aggiornata</td>
                            <td class="opinion-data">{{ stripHtml(answer) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<style scoped>
.card:after {
    margin-top: 0 !important;
}

.label-data {
    width: 4rem;
}

.opinion-data {
    max-width: 100%;
    min-height: 3rem;
}

.opinion-data span {
    display: inline-flex;
    /* inline anziché block */
    align-items: center;
}
</style>

<script>
export default {
    name: "OpinionCard",
    props: {
        id: {
            type: String,
            required: true
        },
        emission_date: {
            type: String,
            required: true
        },
        arguments: {
            type: Array,
            required: true
        },
        subject: {
            type: String,
            required: true
        },
        question: {
            type: String,
            required: true
        },
        answer: {
            type: String,
            required: false
        }
    },
    methods: {
        stripHtml(html) {
            if (!html) return ''; 

            const div = document.createElement('div');
            div.innerHTML = html;
            return div.innerText;
        }
        ,
        convertDate(dataString) {
            const data = new Date(dataString);
            const giorno = data.getDate();
            const mese = data.getMonth() + 1;
            const anno = data.getFullYear();
            return `${giorno.toString().padStart(2, '0')}/${mese.toString().padStart(2, '0')}/${anno}`;
        }
    }
}
</script>
